<template>
	<AppCardPage>
		<AppCard
			title="Maximale Hypotheek"
			card-id="maximaleHypotheek"
			:collapsible="true"
		>
			<SchemaForm :schema="schemas.maximalehypotheekSchema" class="page-form" />
		</AppCard>
		<AppCard
			title="Toegestane lasten"
			card-id="toegestaneLasten"
			:collapsible="true"
		>
			<SchemaForm :schema="schemas.toegestaneLastenSchema" class="page-form" />
		</AppCard>
		<AppCard title="LTV" card-id="ltv" :collapsible="true">
			<SchemaForm :schema="schemas.ltvSchema" class="page-form" />
		</AppCard>
		<AppCard title="Woonquote" card-id="woonquote" :collapsible="true">
			<SchemaForm :schema="schemas.woonquoteSchema" class="page-form" />
		</AppCard>
		<AppCard
			v-if="showValues"
			title="Dev - modelvalues"
			card-id="maxModel"
			:collapsible="true"
		>
			<pre>{{ stringifyObject(state) }}</pre>
		</AppCard>
	</AppCardPage>
</template>

<script setup lang="ts">
import { inject } from "vue";
import useMaximaleHypotheek from "@/store/financiering/tabs/useMaximaleHypotheek";
import { SchemaForm, useSchemaForm } from "formvuelate";
import { stringifyObject } from "@/helpers/uiHelpers";
import { toReactive } from "@vueuse/core";

const { state, schemas } = useMaximaleHypotheek();

const reactiveState = toReactive(state);
useSchemaForm(reactiveState);

const showValues = inject("DEBUG_SHOW_MODELVALUES", false);
</script>
